// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__WEkUi"};